/* eslint-disable max-len */
import { SORT_BY } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the sort by value
 * @param {string} sortBy - One of: "best_match", "sales", "newest", "oldest", "lowest_price", "highest_price", "trending"
 */
export const setSortBy = (sortBy) => {
  searchPageStore.setState({ sortBy })
}

/**
 * Clears the sort by value to best match
 */
export const clearSortBy = () => {
  searchPageStore.setState({ sortBy: SORT_BY.BEST_MATCH })
}
